import React, { useContext } from "react";
import { ExtendTicketLineItem, TicketLineItemExtended } from "../../../Utils/TypeExtensions";
import { Grid } from "@mui/material";
import { PER_DIEMS_LINE_ITEM_TYPES, QUANTITY_TYPE_AMOUNT } from "../../../sharedCode/metadata";
import DetailPage from "../../../Components/navigation/detailPage";
import { DefinitelyAnArray, HasValue } from "../../../sharedCode/HelperMethods";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import PerDiemsRow from "../../../Components/ticket/perDiemsRow";
import { GlobalContext } from "../../../Utils/Contexts";
import { TicketLineItem } from "../../../sharedCode/avroGraphql";
import { saveTicketChanges } from "../../../Utils/TicketDatabase";

export function TicketPerDiems(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);

    return (
        <DetailPage>
            <Grid>
                <Grid container spacing={1} flexDirection={"column"}>
                    {PER_DIEMS_LINE_ITEM_TYPES.map((perDiemsLineItemTypeId) => (
                        <PerDiemsRow key={`row${perDiemsLineItemTypeId}`} lineItemTypeId={perDiemsLineItemTypeId} mergeRowChanges={mergeRowChanges} {...props} />
                    ))}
                </Grid>
            </Grid>
        </DetailPage>
    );

    function mergeRowChanges(lineItemTypeId: number, changes: Record<string, unknown>) {
        // NB - kludge alert - these rows are dynamically created/deleted, ugly code ahead
        const existingIndex = DefinitelyAnArray(props.ticket.LineItems).findIndex((i) => i?.line_item_type_id === lineItemTypeId);
        const rowToUpdate = (existingIndex ?? -1) < 0 ? createNewLineItem(lineItemTypeId) : DefinitelyAnArray(props.ticket.LineItems)[existingIndex];

        if (!rowToUpdate) return;

        const updatedLineItem = { ...rowToUpdate, ...changes } as TicketLineItemExtended;

        const shouldDeleteLineItem = !HasValue(updatedLineItem.comments?.trim()) && !(HasValue(updatedLineItem.quantity) || updatedLineItem.quantity === 0);

        // filter the row out if it has no meaningful values, otherwise merge the changes
        const lineItems =
            (shouldDeleteLineItem
                ? props.ticket?.LineItems?.filter((i) => i?.line_item_type_id !== lineItemTypeId)
                : props.ticket?.LineItems?.map((lineItem) => (lineItem?.line_item_type_id === lineItemTypeId ? updatedLineItem : lineItem))) ?? [];

        // if it's a new row, we have to add it to the list
        if (existingIndex < 0 && !shouldDeleteLineItem) {
            lineItems.push(updatedLineItem);
        }

        if (updatedLineItem.id === props.ticket.nextLocalId) {
            // it is a new row, need to increment nextLocalId
            saveTicketChanges(props.ticket.id, { nextLocalId: props.ticket.nextLocalId - 1, LineItems: lineItems }).catch(() => props.showForceReloadDialogue());
        } else {
            saveTicketChanges(props.ticket.id, { LineItems: lineItems }).catch(() => props.showForceReloadDialogue());
        }
    }

    function createNewLineItem(lineItemTypeId: number) {
        return ExtendTicketLineItem({
            id: props.ticket.nextLocalId,
            line_item_type_id: lineItemTypeId,
            quantity_type_id: QUANTITY_TYPE_AMOUNT,
        } as TicketLineItem);
    }
}
